import styled, { css } from 'styled-components';

export const Label = styled.label(
  ({ theme: { admanColors, spacers } }) => css`
    color: ${admanColors!.gray.light.fg[2]};
    display: inline-block;
    height: 12px;
    margin: ${spacers!.spacer01} 0 ${spacers!.spacer02} 0;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0;
  `
);

export const Description = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    color: ${admanColors!.gray.light.fg[0]};
    display: inline-block;
    height: 12px;
    margin: ${spacers!.spacer01} 0 ${spacers!.spacer08} 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.01em;
    text-align: left;
  `
);

export const StyledContainer = styled.div<{ $error?: boolean; $isFilter?: boolean }>(
  ({ theme: { colors, admanColors }, $error, $isFilter }) => css`
    & > div {
      border: ${$error ? `1px solid ${colors!.colorRedBase}` : 'inherit'};
      border-radius: ${$error ? '4px' : 'inherit'};

      & .control:focus-within {
        border: ${$error ? `2px solid ${colors!.colorRedBase}` : `2px solid ${colors!.colorBlack1}`};
        box-shadow: ${!$isFilter
          ? `0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.dark.bg1[0]}`
          : 'none'};
      }

      span {
        color: ${admanColors!.gray.light.fg[2]} !important;
      }
    }
  `
);
